import type { PaymentsDepositOptions, PaymentsModuleOptions } from '@payments/types'
import type { Merge, PickDeep } from 'type-fest'
import type { PublicPaymentsOptionPath } from '../../publicOptions'
import { useRuntimeConfig } from '#imports'

type ResolvedPaymentsOptions = Merge<PickDeep<PaymentsModuleOptions, PublicPaymentsOptionPath>, { deposit: PaymentsDepositOptions }>

export const usePaymentsConfig = (): ResolvedPaymentsOptions => {
    const config = useRuntimeConfig()

    // Runtime config holds the serialized options shape; cast back to the options type.
    return config.public.payments as unknown as ResolvedPaymentsOptions
}
